<template>
  <!-- TODO: Replace headerButtons with a button bar component that takes md-buttons as a child (maybe in the future when md-components is a considered project?) -->
  <md-report-layout :header-buttons="headerButtons"
                    :loading="loading"
                    :loading-text="loadingText"
                    ref="reportLayout">

    <template v-slot:header-left>
      <md-date-select :init-start="rangeStart" :init-end="rangeEnd" @change="dateRangeChanged" display-mode="header"/>
    </template>

    <template v-slot:employee-list>
      <!--md-date-select :init-start="rangeStart" :init-end="rangeEnd" @change="dateRangeChanged"/-->

      <EmployeeList :loading="loadingEmployees"
                        :employees="employees"
                        :can-select-multiple="true"
                        :init-all-selected="true"
                        @employeeSelected="onEmployeeSelected"
                        style="height: calc(100vh - 400px); margin-bottom: 10px;"/>

      <div class="header" style="font-size: 13px; padding-left: 5px; font-weight:bold; margin-bottom: 10px; text-align: left">
        {{ $t('report.comp.employeesSelected', [countSelectedEmployees, countEmployees]) }}
      </div>

      <div class="header" style="display:flex; flex-direction: row; justify-content: flex-start;">
        <b-button size="sm"
                  variant="outline-secondary"
                  v-on:click="selectAllEmployees"
                  style="border-radius: 0; margin-right: 0.5rem;">
          {{ $t('report.comp.selectAll') }}
        </b-button>
        <b-button size="sm"
                  variant="outline-secondary"
                  v-on:click="deselectAllEmployees"
                  style="border-radius: 0; margin-right: 1rem; justify-self: flex-start;">
          {{ $t('report.comp.deselectAll') }}
        </b-button>

        <b-button size="sm"
                  variant="outline-secondary"
                  v-on:click="toggleShowOnlyActiveEmployees"
                  style="border-radius: 0; margin-left: auto;">
          {{ showOnlyActiveEmployees
            ? $t('report.comp.showAllEmployees')
            : $t('report.comp.showOnlyActiveEmployees')
            }}
        </b-button>
      </div>
    </template>

    <template v-slot:report-settings>
      <ReportConfig :options="reportConfigData" @configChanged="onReportConfigChange"/>
    </template>

    <template v-slot:report-list>
      <ml-report-list :reports="reports"
                      :loading="loadingReports"
                      @deleteReport="openDeleteReportPopup"
                      @downloadReport="downloadReport"
                      @reportClicked="openReport"/>
    </template>

    <template v-slot:button-bar v-if="creatingReport || !canCreateReport">
      <span v-if="creatingReport">
        <i class="fas fa-circle-notch fa-spin"></i>
         {{ $t('report.comp.reportBeingCreated') }}
      </span>
      <span v-else-if="!storeSelected">
        {{ $t('report.comp.selectAtLeastOneStore') }}
      </span>
      <span v-else-if="customRangeUsed">
        {{ $t('report.comp.dynamicRangesNotSupported') }}
      </span>
      <span v-else>
        {{ $t('report.comp.selectAtLeastOneEmployee') }}
      </span>
    </template>

  </md-report-layout>
</template>

<script>
import moment from 'moment';
import MdReportLayout from '@/components/reportcontext/ReportLayout';
import MdDateSelect from '@/components/uicomponents/md-date-select';
import MlReportList from '@/components/uicomponents/ml-report-list';
import ReportConfig from '@/components/uicomponents/reportconfig';
import EmployeeList from '@/components/uicomponents/employeelist';
import { reportMixin } from '@/components/reportcontext/report-mixin';
import { mapGetters } from "vuex";
import VueEventBus from '../../vue-event-bus';

export default {
  name: 'reportbmdexportsums',
  components: {
    MdReportLayout,
    MdDateSelect,
    MlReportList,
    ReportConfig,
    EmployeeList,
  },
  mixins: [ reportMixin ],
  data() {
    return {
      reportType: 'BMDEXPORTSUMS',
      loadingText: this.$t('report.comp.loadingCostCenterQuantityReport'),

      // models: [],
      // individualWageTypes: [],
      mdWageTypes: [],
      contracts: [],
    }
  },
  created: function () {
    // console.log("CREATED");
    VueEventBus.$on("JobReportEvent:jobCreated", this.jobCreated);
    VueEventBus.$on("JobReportEvent:jobStarted", this.jobStarted);
    VueEventBus.$on("JobReportEvent:jobEnded", this.jobEnded);
    VueEventBus.$on("JobReportEvent:jobFailed", this.jobFailed);
  },
  beforeDestroy: function () {
    // console.log("BEFORE DESTROY");
    VueEventBus.$off("JobReportEvent:jobCreated", this.jobCreated);
    VueEventBus.$off("JobReportEvent:jobStarted", this.jobStarted);
    VueEventBus.$off("JobReportEvent:jobEnded", this.jobEnded);
    VueEventBus.$off("JobReportEvent:jobFailed", this.jobFailed);
  },
  destroyed: function () {
    // console.log("DESTROYED");
  },
  mounted() {
    if (this.$store.state.jwt !== undefined && this.$store.state.companyId !== undefined) {

      this.refresh();
    }
  },
  computed: {
    ...mapGetters(['companyId','companySettings', 'storesSettings','employeeContractMap']),
    headerButtons() {
      let helperLinks = [];
      let buttons = [
        {
          classes: 'add-employeetype',
          type: 'block gray',
          disabled: false,
          icon: 'fa-th-list',
          click: ($event) => {
          },
          show: true,
            tooltip: this.$t('report.comp.costCenterQuantityReport'),
            title: this.$t('report.comp.costCenterQuantityReport'),
            helperText: this.$t('report.comp.costCenterQuantityReportDescription')
            //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
        },
        {
          type: 'block green',
          disabled: this.creatingReport || !this.canCreateReport,
          icon: this.creatingReport ? 'fa-redo' : 'fa-file-check',
          click: ($event) => {
            this.createReportProxy();
          },
          show: true,
          tooltip: this.$t('report.comp.createReport'),
          title: this.$t('report.comp.createReport'),
        },
      ];
      let state = {
        buttons: buttons,
        helperLinks: helperLinks,
        showListIconAlways: true,
      };

        state.helperLinks = [
            {
                icon: "fa-video",
                title: this.$t('report.comp.watchTrainingVideo'),
                helperText: this.$t('report.comp.watchTrainingVideoHelper'),
                externalUrl: "https://www.youtube.com/watch_popup?v=BePh4xNJvsY",
                externalLabel: this.$t('report.comp.trainingVideoReports'),
                cancelLabel: this.$t('global.ui.close')
            },
            {
                title: this.$t('report.comp.getSupport'),
                helperText: this.$t('report.comp.getSupportHelper'),
                externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15',
                externalLabel: this.$t('export.comp.contactSupport'),
                cancelLabel: this.$t('global.ui.close')
            }
        ];
      return state;
    },

    canCreateReport() {
      return this.storeSelected && this.employeesSelected && !this.customRangeUsed;
    },
    // employmentModelsSelected() {
    //   const employmentModels = this.reportConfig.employmentModels || {};
    //   return (employmentModels.selectedModels || []).length > 0;
    // },
    // wageTypesSelected() {
    //   const individualWageTypes = this.reportConfig.individualWageTypes || {};
    //   return (individualWageTypes.selectedWageTypes || []).length > 0;
    // },
    storeSelected() {
      const storeIds = this.reportConfig.storeIds || {};
      return (storeIds.selectedStores || []).length > 0;
    },
    employeesSelected() {
      return this.countSelectedEmployees > 0;
    },
    customRangeUsed() {
      return this.rangeMode === 'customRange';
    },
  },
  watch: {
    companyId(newVal, oldVal) {
      console.log("COMPANY ID CHANGED", newVal, oldVal);
      this.refresh(true);
    },
    rangeStart() {
      this.updateReportConfig('reportname', this.getReportName());
    },
  },
  // methods that implement data (BUSINESS) logic. (https://en.wikipedia.org/wiki/Business_logic)
  methods: {
    getReportName() {
      let companyName = this.companySettings && this.companySettings.data && this.companySettings.data[0] ? this.companySettings.data[0].name : this.$t('report.comp.company');
      return this.rangeMode === 'monthlyRange'
          ? this.$t('report.comp.costCenterQuantityWithMonth', {
              title: this.$t('report.comp.costCenterQuantityReport'),
              company: companyName,
              monthYear: moment(this.rangeStart).format('MMMM YYYY')
          })
          : this.$t('report.comp.costCenterQuantityWithRange', {
              title: this.$t('report.comp.costCenterQuantityReport'),
              company: companyName,
              startDate: moment(this.rangeStart).format('DD.MM.YYYY'),
              endDate: moment(this.rangeEnd).format('DD.MM.YYYY')
          });
    },

    async refresh(force = false) {
      this.loading = true;
      this.updateReportConfig('reportname', this.getReportName());

      try {
        await Promise.all([
          this.$helpers.GetCompanySettings(force),
          this.$helpers.GetStoresSettings(force),
          this.$helpers.GetExportSettingsMap(force),
          this.$helpers.GetEmployeeContractMap(force),
          this.getEmployeeContracts(),
          // this.loadMdWageTypes(),
          // this.loadModels(),
          // this.loadIndividualWageTypes(),
          this.loadReports(this.reportType),
          this.loadEmployees(true),
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        this.generateReportConfigOpts();

        // console.log(this.getReportConfigValue('reportname'));
        // reportConfig can be loaded after generating the options, as reportConfig does not overwrite the options
        this.reportConfig = this.loadReportConfig();
        this.updateReportConfig('reportname', this.getReportName());

        // console.log(this.reports);

        this.loading = false;
      }
    },

    generateReportConfigOpts() {
      let view = this;
      let disabled = !this.CheckEnableConfigEdit
      let specialDisabled = !this.CheckEnableConfigSpecialEdit
      const nameSection = this.createReportConfigSection(this.$t('report.comp.documentName'), true, disabled, 'nameSection');
      this.addTextConfigOption(nameSection, 'reportname', this.$t('report.comp.enterDocumentName'), this.getReportName(), true);

      const commentSection = this.createReportConfigSection(this.$t('employee.contract.comment'), false, disabled, 'commentSection');
      this.addTextConfigOption(commentSection, 'reportcomment', this.$t('report.comp.enterComment'));

      const formatSection = this.createReportConfigSection(this.$t('report.comp.fileFormat'), false, disabled, 'formatSection');
      this.addSelectConfigOption(formatSection, 'fileformat', [
        this.addSelectableValue('PDF', 'pdf', true),
        this.addSelectableValue('CSV', 'csv'),
      ]);


      const storeSection = this.createReportConfigSection('Store', false, disabled, 'storeSection');
      view.addSelectConfigOption(storeSection, 'storeIds', [
        view.addSelectableValue(this.$t('report.comp.allStores'),
          this.storesSettings.data.map(store => view.addSelectableValue(store.name, store.id)),
          this.storesSettings.data.map(store => store.id),
          'selectedStores')
      ], true);

      const contentSection = this.createReportConfigSection(this.$t('report.comp.documentContent'), false, disabled, 'contentSection');
      view.addSelectConfigOption(contentSection, 'dailyValues', [
        view.addSelectableValue(this.$t('report.comp.exportVacationSickAsDays'), 1, true),
        view.addSelectableValue(this.$t('report.comp.exportVacationSickAsHours'), 2),
      ]);

      const localeSection = this.createReportConfigSection(this.$t('report.comp.locale'), false, disabled, 'localeSection');
      this.addLanguageSelectConfigOption(localeSection, 'settingLocale', disabled);

      const headerFormatSection = this.createReportConfigSection(  this.$t('report.comp.header'), false, specialDisabled, 'headerFormatSection');
      this.addSelectConfigOption(headerFormatSection, 'settingDateFormat', [
        this.addSelectableValue('DD.MM.YYYY', 'DD.MM.YYYY', true),
        this.addSelectableValue('YYYY-MM-DD', 'YYYY-MM-DD'),
      ]);

    },

    async createReportProxy() {
      if (this.rangeMode === 'customRange') {

        if (this.rangeStart.month() != this.rangeEnd.month() || this.rangeStart.year() != this.rangeEnd.year()) {
          this.$helpers.error(this.$t('employee.data.error'), this.$t('report.comp.startEndSameMonth'));
          return;
        }
        if (this.rangeStart > this.rangeEnd) {
          this.$helpers.error(this.$t('employee.data.error'), this.$t('report.comp.startBeforeEnd'));
          return;
        }

      }
      await this.generateReport();
    },


    getEmployeeContracts: function () {
      let view = this;
      let url = '/api/sec/proxy/md/employee/contracts';

      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/proxy/md/employee/contracts');

      return this.axios({
        method: 'get',
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then(resp => {
        return view.$helpers.GetStores()
          .then(storeResponse => {
            let storeIds = storeResponse.map(s => s.id);
            view.contracts = {};
            Object.values(resp.data).forEach(contract => {
              if (storeIds.includes(contract.storeId)) {
                if (view.contracts.hasOwnProperty(contract.remoteId)) {
                  view.contracts[contract.remoteId].push(contract);
                } else {
                  view.contracts[contract.remoteId] = [];
                  view.contracts[contract.remoteId].push(contract);
                }
              }
            });
            // console.log(view.contracts);
          });
      }).catch(error => {
        console.log(error);
      });
    },


    async generateReport() {
      this.creatingReport = true;

      const employeeIds = this.selectedEmployeeIds;

      const dateFormats = {
        'DD.MM.YYYY': 'dmY',
        'YYYY-MM-DD': 'Ymd',
      };
      const dateFormat = dateFormats[this.reportConfig.settingDateFormat] || 'dmY';

      const hourFormats = {
        '3': '3',
        '2': '2',
        'Hm': 'Hm',
      };
      const hourFormat = hourFormats[this.reportConfig.settingHourFormat] || 'Hm';

      let locale = this.reportConfig.settingLocale || 'de';
      if (locale === 'current') {
        locale = this.$i18n.locale;
      }

      const name = this.reportConfig.reportname;
      const comment = this.reportConfig.reportcomment;
      const config = {
        'year': this.rangeStart.year(),
        'month': this.rangeStart.month() + 1,
        'headerDateFormat': dateFormat,
        'hourFormat': hourFormat,
        'storeIds': this.reportConfig.storeIds.selectedStores,
        // 'monthlyWageTypes': this.reportConfig.monthlyWageTypes.selectedMonthlyWageTypes,
        // 'dailyWageTypes': this.reportConfig.dailyWageTypes.selectedDailyWageTypes,
        // 'employmentModelsBool': false,
        // 'employmentModels': this.reportConfig.employmentModels.selectedModels,
        // 'wageTypesBool': false,
        // 'individualWageTypes': this.reportConfig.individualWageTypes.selectedWageTypes,
        // 'employeeSelection': this.reportConfig.employeeSelection,
        // 'showOnlySums': this.reportConfig.showOnlySums,
        // 'employeeSums': this.reportConfig.sums.selectedSums.includes('employeeSums'),
        // 'employmentModelSums': this.reportConfig.sums.selectedSums.includes('employmentModelSums'),
        // 'wageTypeSums': this.reportConfig.sums.selectedSums.includes('wageTypeSums'),
        // 'totalSums': this.reportConfig.sums.selectedSums.includes('totalSums'),
        // 'groupBy': this.reportConfig.groupBy,
        // 'sortEmployeesBy': this.reportConfig.sortEmployeesBy,
        // 'sortEntriesBy': this.reportConfig.sortEntriesBy,
        'documentComment': comment ?? "",
        'headerLogo': 'ml',
        'fileformat': this.reportConfig.fileformat ?? 'pdf',
        'dailyValues': this.reportConfig.dailyValues ?? 1,
        'language': locale,
      };

      if (this.rangeMode === 'customRange') {
        config.fromDate = this.rangeStart.format();
        config.toDate = this.rangeEnd.format();
      }

      // console.log(employeeIds);
      // console.log(config);

      await this.createReport(this.reportType, name, comment ? comment : "", config);

    },
    jobCreated: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB CREATED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 50);
    },
    jobStarted: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB STARTED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 100);
    },
    jobEnded: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB ENDED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 200);
    },
    jobFailed: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB FAILED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 200);
    },
    reloadDocuments: function () {
      this.loadReports(this.reportType);
    },


    // these won't be needed for now
    loadModels: function () {
      let view = this;
      let params = { companyId: view.$store.state.companyId };
      return view.$helpers
      .GetCall("/api/sec/employmentModels", params)
      .then((response) => {
        let data = response.data.data;
        let tmp = [];
        for (let i = 0; i < data.length; i++) {
          let item = {
            id: data[i].id,
            number: data[i].number,
            name: data[i].name,
          };
          tmp.push(item);
        }
        view.models = tmp.slice();
        console.log("models", view.models);
      })
      .catch((e) => {
        console.log(e);
      });
    },
    loadIndividualWageTypes: function () {
      let view = this;
      let params = { companyId: view.$store.state.companyId };
      return view.$helpers
      .GetCall("/api/sec/individualWageTypes", params)
      .then((response) => {
        let data = response.data.data;
        let tmp = [];
        for (let i = 0; i < data.length; i++) {
          let item = {
            id: data[i].id,
            numberString: data[i].numberString,
            name: data[i].name,
            details: data[i].details,
          };
          tmp.push(item);
        }
        view.individualWageTypes = tmp.slice();
        console.log("individualWageTypes", view.individualWageTypes);
      })
      .catch((e) => {
        console.log(e);
      });
    },
    loadMdWageTypes: function () {
      let view = this;
      return view.$helpers
      .GetCall("/api/sec/wagetypes", {})
      .then((response) => {
        console.log(response);
        view.mdWageTypes = [];

        for (let i = 0; i < response.data.length; i++) {
          // 0 is causing an issue with the select component
          response.data[i].id = response.data[i].id == 0 ? 1000 : response.data[i].id;
          response.data[i].enumKey = response.data[i].id;
        }
        view.mdWageTypes = response.data;
        console.log("mdWageTypes", view.mdWageTypes);
      })
      .catch((e) => {
        console.log(e);
      });
    },

    prepareMonthlyPayload(config) {
      let payload = {};
      payload.year = '' + config.year;
      payload.month = config.month < 10 ? '0' + config.month : '' + config.month;
      payload.exportSettings = {};
      payload.exportSettings.selectedWageTypes = config.monthlyWageTypes;
      payload.exportSettings.selectedStores = config.storeIds;
      payload.exportSettings.id = 0;
      payload.exportSettings.name = this.$t('report.comp.standard');
      payload.exportSettings.availableFields = [
          {key: "externalCompanyId", name: this.$t('report.comp.companyId'), newName: this.$t('export.builder.company'), checked: true},
          {key: "externalEmployeeId", name: this.$t('comp.ui.employeeId'), newName: this.$t('report.comp.employeeNumber'), checked: true},
          {key: "month", name: this.$t('employee.comp.month'), newName: this.$t('employee.comp.month'), checked: true},
          {key: "rollUpMonth", name: this.$t('export.builder.rollUpMonth'), newName: this.$t('export.builder.rollUpMonth'), checked: true},
          {key: "lohnart", name: this.$t('settings.wage.wageType'), newName: this.$t('settings.wage.wageType'), checked: true},
          {key: "paidWorkTime", name: this.$t('report.comp.paidValue'), newName: this.$t('report.comp.paidValue'), checked: true},
          {key: "contentName", name: this.$t('export.builder.contentLabel'), newName: this.$t('report.comp.content'), checked: true},
          {key: "employeeName", name: this.$t('report.comp.employeeName'), newName: this.$t('report.comp.name'), checked: true},
          {key: "storeId", name: "storeId", newName: "storeId", checked: true},
          {key: "remoteId", name: "remoteId", newName: "remoteId", checked: true}
      ];
        payload.exportSettings.availableFieldsAdditional = [
            {
                key: "headerAdditional",
                name: this.$t('export.builder.listStructure'),
                item: {
                    key: 0,
                    label: this.$t('report.comp.doNotPrintColumnLabels')
                },
                checked: true
            },
            {
                key: "monthAdditional",
                name: this.$t('employee.comp.month'),
                item: {
                    key: "current",
                    label: this.$t('report.comp.currentMonth'),
                    selected: true
                },
                checked: true
            },
            {
                key: "rollUpMonthAdditional",
                name: this.$t('export.builder.rollUpMonth'),
                item: {
                    key: "current",
                    label: this.$t('report.comp.currentMonth')
                },
                checked: true
            },
            {
                key: "paidWorkTimeAdditional",
                name: this.$t('report.comp.paidValue'),
                item: {
                    key: 0,
                    label: this.$t('report.comp.exportZeroValues'),
                    selected: true
                },
                checked: true
            },
            {
                key: "donhauserGroup",
                use: false
            }
        ];
      return payload;
    },
    prepareDailyPayload(config) {
      let payload = {};
      payload.year = '' + config.year;
      payload.month = config.month < 10 ? '0' + config.month : '' + config.month;
      payload.exportSettings = {};
      payload.exportSettings.selectedWageTypes = config.dailyWageTypes;
      payload.exportSettings.selectedStores = config.storeIds;
      payload.exportSettings.id = 0;
      payload.exportSettings.name = this.$t('report.comp.standard');
        payload.exportSettings.availableFields = [
            { key: "dailyExternalCompanyId", name: this.$t('report.comp.companyId'), newName: this.$t('export.builder.company'), checked: true },
            { key: "dailyExternalEmployeeId", name: this.$t('comp.ui.employeeId'), newName: this.$t('global.ui.pNumber'), checked: true },
            { key: "dailyLohnart", name: this.$t('settings.wage.wageType'), newName: this.$t('report.comp.type'), checked: true },
            { key: "dailyFrom", name: this.$t('report.comp.startDate'), newName: this.$t('report.comp.from'), checked: true },
            { key: "dailyTo", name: this.$t('report.comp.endDate'), newName: this.$t('report.comp.to'), checked: true },
            { key: "dailyPayoutValue", name: this.$t('report.comp.value'), newName: this.$t('report.comp.management'), checked: true },
            { key: "dailyPayoutHoursValue", name: this.$t('report.comp.valuePaid'), newName: this.$t('report.comp.paid'), checked: true },
            { key: "dailyProcessingFlag", name: this.$t('report.comp.processingFlag'), newName: this.$t('report.comp.processingFlag'), checked: true },
            { key: "dailyContentName", name: this.$t('export.builder.contentLabel'), newName: this.$t('report.comp.content'), checked: true },
            { key: "dailyEmployeeName", name: this.$t('report.comp.employeeName'), newName: this.$t('report.comp.name'), checked: true },
            { key: "storeId", name: "storeId", newName: "storeId", checked: true },
            { key: "remoteId", name: "remoteId", newName: "remoteId", checked: true }
        ];
        payload.exportSettings.availableFieldsAdditional = [
            {
                key: "headerAdditional",
                name: this.$t('export.builder.listStructure'),
                item: {
                    key: 0,
                    label: this.$t('report.comp.doNotPrintColumnLabels')
                },
                checked: true
            },
            {
                key: "dailyPayoutValueAdditional",
                name: this.$t('report.comp.value'),
                item: {
                    key: 1,
                    label: this.$t('report.comp.valueInDays'),
                    selected: true
                },
                checked: true
            },
            {
                key: "dailyPayoutHoursValueAdditional",
                name: this.$t('report.comp.valuePaid'),
                item: {
                    key: 0,
                    label: this.$t('report.comp.valueInHours')
                },
                checked: true
            },
            {
                key: "dailyProcessingFlagAdditional",
                name: this.$t('report.comp.processingFlag'),
                item: {
                    key: 0,
                    label: this.$t('report.comp.createAbsencesNew'),
                    selected: true
                },
                checked: true
            }
        ];
      return payload;
    },
    getCsvExportFromBackend(type, payload) {
      let view = this;

      let baseUrl = '';
      if (type == 'monthly') {
        baseUrl = '/api/sec/bmd/exports/MFS/create';
      } else if (type == 'individual-wagetypes') {
        baseUrl = '/api/sec/iwt/exports/create';
      } else if (type == 'daily') {
        baseUrl = '/api/sec/bmd/exports/AS/create';
      } else if (type == 'pp') {
        baseUrl = '/api/sec/bmd/exports/PP/create';
      } else {
        console.error('Unknown export type');
        return Promise.reject('Unknown export type');
      }

      let url = baseUrl;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);

      return this.axios({
        method: 'post',
        data: payload,
        headers: {
          'AUTHORIZATION': "Bearer "+this.$store.state.jwt
        },
        url: url
      });

    },

  },
}
</script>

<style scoped>
/* remove max-height from sub component: 100vh would cut off long lists */
>>>.config-entry>.body.entry-expanded {
  max-height: 100% !important;
}
</style>
